import { render, staticRenderFns } from "./Variante.vue?vue&type=template&id=7fad040f&scoped=true&"
import script from "./Variante.vue?vue&type=script&lang=js&"
export * from "./Variante.vue?vue&type=script&lang=js&"
import style0 from "./Variante.vue?vue&type=style&index=0&id=7fad040f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fad040f",
  null
  
)

export default component.exports